import type { Offer } from '~/api/pricing-offers'
import { useTranslations } from '~/composables/translate/translations'
import { useOfferStore } from '~/stores/offer'

// TODO: use `offer` store? Why do we need `offer-utils` composable if we already have `offer` store?

export function formattedOfferPricePerDay(offer: Offer, language: string): string | undefined {
  return formatAmountPerDay(language, offer, offer.price)
}

export function formattedOfferPrice(offer: Offer, language: string = useTranslations().language.value): string | undefined {
  return formatAmount(language, offer.price, offer.currency)
}

export function formatAmount(language: string, amount?: number, currency: string = 'EUR'): string | undefined {
  return amount?.toLocaleString(
    language,
    { style: 'currency', currency, maximumFractionDigits: 2 },
  )
}

export function formatAmountPerDay(language: string, offer?: Offer, amount?: number, needDeviceByDuration: boolean = true): string | undefined {
  if (!offer || !amount)
    return undefined
  const duration = getOfferDaysDuration(offer)
  if (!duration)
    return undefined

  const priceToFormat = needDeviceByDuration ? amount / duration : amount
  return formatAmount(language, priceToFormat, offer.currency)
}

export function getOfferDaysDuration(offer: Offer | undefined = useOfferStore().selectedOffer): number | undefined {
  if (offer === undefined) {
    return undefined
  }
  const durationMinutes = offer.properties
    ?.find(property => property.tags?.includes('package_duration_minutes'))
    ?.value

  return durationMinutes
    ? Math.trunc(Number(durationMinutes) / 1440) || 1
    : undefined
}
